<template>
	<div>
		<CCard>
			<CCardHeader> 1) Sélectionnez le point de vente concerné </CCardHeader>
			<CCardBody>
				<CRow>
					<CCol md="6">
						<div class="form-group" v-if="!loading">
							<label>Point de vente</label>
							<GTreeView
								input-name="pointOfSale"
								placeholder="Recherchez un point de vente"
								label-prop="concated"
								:multiple="false"
								:local-data="localData"
								idProp="id"
								v-on:update:selected="data => (gtreeValue = data)" />
						</div>
						<Loading v-if="loading" />
					</CCol>
				</CRow>

				<CRow>
					<CCol md="12" class="text-right">
						<CButton color="primary" @click="onSubmit"> Valider </CButton>
					</CCol>
				</CRow>
			</CCardBody>
		</CCard>
	</div>
</template>

<script>
	import GTreeView from '../../../components/ghostlexly-components/GTreeView';
	import Loading from '../../../components/loading';
	import { map, assign } from 'lodash';

	export default {
		name: 'link-point-of-sale',

		components: {
			Loading,
			GTreeView,
		},

		data() {
			return {
				loading: true,
				localData: [],
				gtreeValue: null,
			};
		},

		mounted() {
			this.$axios.get('/api/point_of_sales?itemsPerPage=9999').then(res => {
				this.localData = map(res.data['hydra:member'], item => {
					assign(item, {
						concated: `[${item.reference}] ${item.name} - ${item.postalCode}, ${item.city}`,
					});
					return item;
				});

				this.loading = false;
			});
		},

		methods: {
			onSubmit() {
				if (this.gtreeValue != null) {
					this.$router.push({
						name: 'Lier à un point de vente 2/2',
						params: { id: this.gtreeValue },
					});
				}
			},
		},
	};
</script>
